export interface ServiceError {
    code: ServiceErrorCode;
    description: string;
}

export type ServiceErrorResponse = ServiceError[];

export enum ServiceErrorCode {
    PROFILE_INCOMPLETE = 'PROFILE_INCOMPLETE',
}
